import React, { FormEvent, useState } from "react";

interface Props {
  authenticate: (password: string) => void;
}

export const AuthenticationForm: React.FC<Props> = ({ authenticate }) => {
  const [username, setUsername] = useState("Arodene Finance");
  const [password, setPassword] = useState("");

  const submitPassword = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    authenticate(password);
  };

  return (
    <main className="authContainer">
      <form action="/" autoComplete="on" className="authForm" method="post" onSubmit={submitPassword}>
        <label className="authLabel" htmlFor="finance-password">
          Please authenticate to continue
        </label>
        <label className="authInputLabel authVisuallyHidden" htmlFor="finance-username">
          Account
        </label>
        <input
          autoComplete="username"
          className="authUsernameInput authVisuallyHidden"
          id="finance-username"
          name="username"
          onChange={(event) => setUsername(event.target.value)}
          type="text"
          value={username}
        />
        <label className="authInputLabel" htmlFor="finance-password">
          Password
        </label>
        <input
          autoComplete="current-password"
          autoFocus
          className="authPasswordInput"
          id="finance-password"
          name="password"
          onChange={(event) => setPassword(event.target.value)}
          type="password"
          value={password}
        />
        <button className="authSubmitButton" type="submit">
          Authenticate
        </button>
      </form>
    </main>
  );
};
